import { SafeUrl } from '@angular/platform-browser';
import {
    ClientIntegration,
    IntegrationOptionType,
} from 'app/modules/settings/interfaces/client-integration';
import { ContactModel } from '../../settings/interfaces/company-account-data';

export enum WelcomeEmailSendStatus {
    Pending = 0,
    Expired,
    NotSent,
    Delivered,
    EmployeeTerminated,
    Unknown,
}

export interface ClientInterface {
    clientFullname: string;
    clientShortName: string;
    active: boolean;
    isSelected?: boolean;
    tabIndex?: number;
    nvLite: boolean;
    subscriptionName: string;
    clientSubscriptionTypeKey: number;
    dataInstance: string;
}

export enum WelcomeEmailState {
    Unknown,
    Pending,
    Expired,
    NotRequired,
}

export interface Employee {
    lengthOfEmployment?: string;
    primaryIdentifier: string;
    firstName: string;
    lastName: string;
    lfName: string;
    firstNameProper: string;
    jobTitle: string;
    mobilePhone: string;
    nmls?: string;
    isUser: boolean;
    loginEmail: string;
    clientShortName?: string;
    location: string;
    locationIdentifier?: string;
    employeeStatus: string;
    userStatus: string;
    city?: string;
    state?: string;
    fullTime: boolean;
    hireDate: Date;
    createDate: Date;
    inActiveDate: Date;
    terminationDate: Date;
    userGUID?: string;
    pictureSrc?: SafeUrl;
    positionName: string;
    permissionSetName: string;
    isSupervisor?: boolean;
    supervisorIdentifier?: string;
    isClientPowerUser?: boolean;
    onLeave?: boolean;
    lastLoginDate?: Date;
    welcomeEmailExpirationDate?: Date;
    sendEmail?: boolean;
    convertToUser?: boolean;
    welcomeEmailStatus?: WelcomeEmailSendStatus;
    welcomeEmailState?: WelcomeEmailState;
    actionToggle?: boolean;
    isActive?: boolean;
    hierarchyLevel?: string;
    isClientAdmin?: boolean;
    isSelected?: boolean;
    roleName?: string;
}
export interface EmployeeIdentifier {
    employeeIdentifierKey: number;
    clientIntegrationSource: string;
    identifierType: string;
    description: string;
    identifier: string;
    isPrimary: boolean;
}

export interface ClientCustomRole {
    roleOrder: number;
    roleName: string;
    description: string;
}
export interface ClientIdentifier {
    identifierType: string;
    identifier: string;
}
export interface ClientIdentifierType {
    identifierTypeKey: number;
    identifierType: string;
}
export interface ClientIdentifierUpdate {
    identifierType: string;
    identifier: string;
    identifierOld?: string;
    isActive: boolean;
    activeDate?: Date;
    inActiveDate?: Date;
    lastMod?: Date;
    lastModUserKey?: number;
}
export interface AccountDetails {
    fullName: string;
    shortName: string;
    companyURL?: string;
    hubSpotUrl?: string;
    compenSafeUrl?: string;
    clientKey?: number;
    subscriptionType: string;
    clientSubscriptionTypeKey: number;
    contractDate?: Date;
    renewalDate?: Date;
    activeDate?: Date;
    inActiveDate?: Date;
    goLiveDate?: Date;
    loanSeedDate?: Date;
    cS_CompanyID: string;
    use_Hourly_KPI?: boolean;
    identifiers?: ClientIdentifier[];
    useSSO?: boolean;
    nvLite: boolean;
    lgDataSwapKey?: string;
    isActive: boolean;
    isLoginDisabled: boolean;
    entityClassification: string;
    customerNumber: string;
}
export interface ClientInformationInterface {
    action: string;
    clientDetails: AccountDetails;
    clientIntegrationSources: ClientIntegrationSource[];
    contacts: ContactModel[];
    identifiers: ClientIdentifier[];
    employeeIdentifiers: ClientIntegrationSource[];
}

export interface ClientInformationSources {
    primaryEmployeeSource: string;
    primaryBranchSource: string;
    technicalEmail: string;
    primaryEmail?: string;
    idHmdaLEI: string;
    idNMLS: string;
    idAnalytics: string;
}

export interface ClientIntegrationSource {
    source: string;
    description: string;
    id?: number;
    isNew?: boolean;
    isPrimaryForBranchIdentifier?: boolean;
    isPrimaryForEmployeeIdentifier?: boolean;
    isAlternateForEmployeeIdentifier?: boolean;
    alternateEmployeeIdentifierSource?: string;
    identifierType?: string;
    defaultParameters?: any;
    isPrimary?: boolean;
    integrationOption?: IntegrationOptionType;
}

export interface IntegrationSource {
    integrationSourceKey: number;
    integrationSource: string;
    defaultParameters?: any;
    canBePrimaryForEmployee: boolean;
    canBePrimaryForBranch: boolean;
}

export interface AlternateSourceType {
    alternateSourceType: string;
    alternateSourceIcon?: string;
}

export interface ClientEmployeeIdentifier {
    identifierType: string;
    clientIntegrationSourceKey?: number;
    identifierDescription: string;
    integrationSourceDesc: string;
    isActive: boolean;
    isDeleted: boolean;
    isPrimaryForEmployeeIdentifier: boolean;
    isPrimaryForBranchIdentifier: boolean;
    isAlternateForEmployeeIdentifier: boolean;
    alternateEmployeeIdentifierSource: string;
    clientIdentifierTypeKey: number;
}
